import { forgotPassword } from './reducers';
export default forgotPassword;
